import React, {useState, useEffect, useContext} from 'react';
import styled from 'styled-components';
import OutputText from '@ey/canvascoreservices/OutputText';
import DataContainer from '../../Common/EngagementGroups/DataContainer';
import ErrorSummary from '../../Common/ErrorSummary/ErrorSummary';
import {labels, currentResource} from '../../../util/utils';
import TabItemContainer from './TabItemContainer';
import selectAllClients from '../../../reducers/Clients/selectors/selectAllClients';
import {getClientEngagements, clearClientEngagements} from '../../../actions/Engagement/engagementactions';
import env from '../../../util/env';
import {serviceURL, createProjectStepsIndex} from '../../../util/uiconstants';
import {clientEngagementsSelector, selectedClientsSelector} from './Helper/dataSelector';
import {useDispatch, useSelector} from 'react-redux';
import EngagementItem from './EngagementItem';
import Step3OrgChart from './step3OrgChart';
import {ProjectContext} from './Helper/context';
import * as projectActionTypes from '../CreateProjectClassic/Helper/projectActionTypes';

const CreateProjectStep3 = (props) => {
	const allClients = useSelector(selectAllClients);

	// Below will maintain  list of selected engagement in available engagements
	const [selectedEngagments, setSelectedEngagements] = useState([]);
	const [connectData, setConnectedDataEngagements] = useState([]);

	const [showDetailsState, setShowDetailsState] = useState(false);
	const [showTabName, setShowTabName] = useState('1');
	// we can pass props and some filterdata to useSelector hook if we want to filter data based on some condition
	let {clientEngagements} = clientEngagementsSelector(props, {showAll: true});
	let selectedClients = selectedClientsSelector();
	const globalDispatch = useDispatch();
	//Context
	const {dispatch} = useContext(ProjectContext);
	const isEditMode = useSelector((state) => state.isEditMode.activated);
	const project = useSelector((store) => store.newProject);

	useEffect(() => {
		if (isEditMode) {
			if (allClients.length > 0 && selectedClients.length === 0) {
				dispatch({
					type: projectActionTypes.UPDATE_SELECTED_CLIENTS,
					payload: {clients: project.clients}
				});
			}
		}
	}, [allClients]);

	useEffect(() => {
		localStorage.removeItem('StateStep3OrgChart');
		return () => {
			localStorage.removeItem('StateStep3OrgChart');
		};
	}, []);

	// If clients selection is changed in step 1 and we fetched the client engagements again, ensure that node engagements are updated
	// with available engagements data. Remove engagements which are not present for selected clients.
	useEffect(() => {
		if (clientEngagements && props.nodes) {
			let availableEngagements = [];
			if (!_.isEmpty(clientEngagements)) {
				clientEngagements.forEach((eng) => availableEngagements.push(eng.canvasEngagementId));

				let updatedNodes = props.nodes.map((n) => {
					// let nodeEngagements = n.engagements.filter((engagement) => availableEngagements.includes(engagement));
					// if (n.engagements.length > 0 && nodeEngagements.length === 0) {
					// 	nodeEngagements=[...n.engagements]
					// }
					let updatedNode = {
						...n,
						engagements: n.engagements,
						engagementLabel: labels.connectedToEngagements(n.engagements.length)
					};
					return updatedNode;
				});
				props.setNodes(updatedNodes);
			}
		}
	}, [clientEngagements]);

	useEffect(() => {
		if (props.nodes && clientEngagements) {
			let connectedEngagements = [];
			props.nodes.forEach((node) => {
				if (node.engagements.length > 0) {
					let nodeLevel = getNodeLevel(node);
					node.engagements.forEach((engagement) => {
						let engagementDetail = clientEngagements.find((eng) => eng.canvasEngagementId == engagement);
						if (!engagementDetail) {
							engagementDetail = {canvasEngagementId: engagement, engagementDescription: labels.notAvailable};
						}
						connectedEngagements.push({
							...engagementDetail,
							entityId: node.id,
							entityName: node.entityName,
							nodeLevel: nodeLevel
						});
					});
				}
			});
			setConnectedDataEngagements(connectedEngagements);
		}
	}, [props.nodes]);

	// Find the level of node items. It is required to apply css on connected tab data.
	const getNodeLevel = (node) => {
		let parentExist = false;
		let grandParentExist = false;
		let greatGrandParentExist = false;
		let pId = node.pid;
		if (pId) {
			parentExist = true;
			let gpId = props.nodes.find((node) => node.id == pId) ? props.nodes.find((node) => node.id == pId).pid : null;
			if (gpId) {
				grandParentExist = true;
				let ggpId = props.nodes.find((node) => node.id == gpId)
					? props.nodes.find((node) => node.id == gpId).pid
					: null;
				if (ggpId) {
					greatGrandParentExist = true;
				}
			}
		}
		return greatGrandParentExist ? 4 : grandParentExist ? 3 : parentExist ? 2 : 1;
	};

	const loadData = () => {
		const url = `${env.getBaseURL(serviceURL)}ClientEngagements`;
		let canvasEngagements = [];
		const canvasClients = selectedClients
			.filter((client) => client.source.indexOf('EY Canvas') > -1)
			.map((client) => client.clientCode);
		allClients.forEach((client) => {
			// sometime value of client.engagementIds[0] is null
			if (canvasClients.indexOf(client.clientCode) !== -1 && client.engagements.length > 0 && client.engagements[0]) {
				canvasEngagements.push(...client.engagements);
			}
		});
		const independenceEntityIds = [];
		const independenceClients = selectedClients.filter((client) => client.source.indexOf('Independence') > -1);
		_.forEach(independenceClients, (x) => {
			if (x.entityIds) {
				independenceEntityIds.push(...x.entityIds);
			}
		});

		// Get the engagement details for which details are not available and which are in connected list
		const connectedEngagementIds = [];
		const universalEngagementIds = [];
		_.forEach(project?.orgStructure, (x) => {
			if (x.engagements) {
				connectedEngagementIds.push(...x.engagements);
			}
		});
		_.forEach(canvasEngagements, (x) => {
			if (x.canvasEngagementId) {
				universalEngagementIds.push(x.canvasEngagementId);
			}
		});
		const engagementIds = connectedEngagementIds.filter((x) => !universalEngagementIds.includes(x));

		const body = {
			financial: selectedClients
				.filter((client) => client.source.indexOf('Financial') > -1)
				.map((client) => client.clientCode),
			Independence: independenceEntityIds,
			canvasEngagements: engagementIds,
			projectId: project && project.Id ? project.Id : project?.id
		};

		const payload = {
			canvasEngagements: canvasEngagements
		};

		globalDispatch(getClientEngagements(url, body, payload))
			.then(() => {})
			.catch(() => {});
	};

	const removeEngagementFromNode = (nodeId, engagementId) => {
		let updatedNodes = props.nodes.map((n) => {
			if (n.id.toString() === nodeId.toString()) {
				let connectedEngagementsCount = n.engagements.length - 1;
				let x = {
					...n,
					engagements: n.engagements.filter((x) => x !== engagementId),
					engagementLabel: labels.connectedToEngagements(connectedEngagementsCount)
				};

				return x;
			}
			return n;
		});
		props.setNodes(updatedNodes);
	};

	// If user clicks on engagement card or its checkboxes.
	// If unchecked item is dragged, then update selectedEngagements to have only this engagement and unselect other card.
	// Else, add or remove engagement ids from the selected counts.
	const onEngagementSelectionChange = (checkedEngagementId, isChecked) => {
		if (isChecked == undefined) {
			setSelectedEngagements([checkedEngagementId]);
		} else {
			if (isChecked) {
				setSelectedEngagements((prevState) => [...prevState, checkedEngagementId]);
			} else {
				setSelectedEngagements((prevState) => prevState.filter((engagement) => engagement != checkedEngagementId));
			}
		}
	};

	const onRemoveItem = (nodeId, engagementId) => {
		// If user disconnect any engagement, ensure tooltip is hidden for entity in org chart.
		var tooltip = document.getElementById('tooltip-step3');
		tooltip.classList.remove('visible');

		let newConnectedEngagements = connectData.filter((engagement) => engagement.canvasEngagementId != engagementId);
		setConnectedDataEngagements(newConnectedEngagements);
		removeEngagementFromNode(nodeId, engagementId);
	};

	const childRenderItem = (renderProps) => {
		return (
			<EngagementItem
				key={renderProps.data.canvasEngagementId}
				data={renderProps.data}
				isItemDraggable={renderProps.isItemDraggable}
				showRemoveIcon={renderProps.showRemoveIcon}
				onRemoveItem={onRemoveItem}
				showDetailsSwitch={renderProps.showDetailsSwitch}
				showTabName={renderProps.showTabName}
			/>
		);
	};

	const renderEngagementItem = (config, data) => {
		let canvasEngagementId = data.canvasEngagementId;
		let selectedTabId = config.groupConfig.activeTab;
		let isItemChecked = selectedEngagments.includes(data.canvasEngagementId);

		return (
			<TabItemContainer
				key={canvasEngagementId}
				parentKeyListener={`${canvasEngagementId}${selectedTabId}_3`}
				id={canvasEngagementId}
				isItemChecked={isItemChecked}
				data={data}
				onSelectionChange={onEngagementSelectionChange}
				selectedItems={selectedEngagments}
				isItemDraggable={selectedTabId == '1'}
				showCheckbox={selectedTabId == '1'}
				connectedData={connectData}
				childRenderItem={childRenderItem}
				CurrentStep={3}
				showDetailsSwitch={showDetailsState}
				showTabName={showTabName}
			></TabItemContainer>
		);
	};

	const configuration = {
		searchAttributes: {
			allowSearch: true,
			searchKeys: [
				{
					key: 'canvasEngagementId'
				},
				{
					key: 'engagementDescription'
				},
				{
					key: 'clientEngagementCode'
				},
				{
					key: 'clientEngagementName'
				}
			]
		},
		tabsParameters: {
			tabs: [
				{
					id: '1',
					label: labels.availableLabel,
					value: 0
				},
				{
					id: '2',
					label: labels.connectedLabel,
					value: 0
				}
			]
		},
		sortAttribute: 'engagementDescription',
		viewByOption: {
			options: currentResource.engagementsViewBy
		},
		render: renderEngagementItem,
		showViewOptions: function(tabValue) {
			if (tabValue == '1') {
				return true;
			}
			false;
		},
		idAttributeName: 'canvasEngagementId',
		viewConnectedItemBy: {id: 1, label: 'entityName', value: 'entityName', groupAttributeName: 'entityName'}
	};

	useEffect(() => {
		if (props.continueToNextStep) {
			props.setActiveStepIndex(createProjectStepsIndex.connectToEYCanvas);
		}
		props.setContinueToNextStep(false);
	}, [props.continueToNextStep]);

	const showDetailsHandler = (status) => {
		setShowDetailsState(status);
	};

	const tabSwitchHandler = (tabActive) => {
		setShowTabName(tabActive);
	};

	return (
		<StyledStep3Section className="step3">
			<ErrorSummary />
			<div className="header-content">
				<OutputText h4>{labels.step3InstructionHeader}</OutputText>
				<OutputText light>{labels.step3InstructionPara}</OutputText>
			</div>
			<section className="list-orgChart-wrap">
				{selectedClients.length > 0 && selectedClients[0].source && (
					<DataContainer
						configuration={configuration}
						data={clientEngagements}
						connectedData={connectData}
						selectedItems={selectedEngagments}
						setSelectedItems={setSelectedEngagements}
						isServerSide={true}
						showDetailsHandler={showDetailsHandler}
						showDetailsToggleSwitch={true}
						tabSwitchHandler={tabSwitchHandler}
						loadData={loadData}
						key="step3projectcreatedatacontainer"
						parentName={'createprojectstep3'}
						placeholderMessage={labels.placeholderStep3NoEngagementMessage}
						placeholderConnectedTabMessage={labels.placeholderStep3NoConnectedEngagementMessage}
						searchPlaceholder={labels.searchEngagements}
						filterAvailableData={true}
						allItemConnectedMessgae={labels.placeholderStep3AllEngagementsConnected}
					></DataContainer>
				)}

				<Step3OrgChart
					nodes={props.nodes}
					setNodes={props.setNodes}
					selectedEngagments={selectedEngagments}
					setSelectedEngagements={setSelectedEngagements}
					allEngagements={clientEngagements}
				></Step3OrgChart>
			</section>
		</StyledStep3Section>
	);
};

export default CreateProjectStep3;

const StyledStep3Section = styled.section`
	height: 100%;
	.header-content {
		display: flex;
		flex-direction: column;
	}

	.list-orgChart-wrap {
		display: flex;
		// height: 71.3rem; //100%;
		.list-container-wrapper {
			width: 29%;
			margin-right: 2rem;
			.connected-content {
				.motif-toggle-switch-wrapper,
				.engagement-partner-wrap,
				.client-label-wrap,
				.eng-id-wrap,
				.code-label-wrap {
					display: none;
				}
				.client-value,
				.eng-id-value,
				.code-value {
					width: 100%;
					display: inline-block;
				}

				.engagement-name-wrap,
				.client-name-wrap {
					span {
						&.eng-id,
						&.client-code {
							max-width: 45%;
						}
					}
				}
			}
			.available-content {
				.separator,
				.eng-id {
					display: none;
				}
				.step3-connected-eng-wrap {
					width: 100%;

					&.show-details {
						.engagement-name-wrap,
						.client-name-wrap {
							flex-direction: column;
						}
					}
				}
				.engagement-name-wrap,
				.client-name-wrap {
					display: flex;
					width: 100%;
					span {
						&.eng-name,
						&.client-name {
							max-width: 100%;
						}
					}
				}

				.client-name,
				.eng-id,
				.client-code {
					display: flex;

					.client-value,
					.eng-id-value,
					.code-value {
						margin-left: 0.5rem;
						// width: calc(100% - 4rem);
						width: 100%;
						display: inline-block;
					}

					.client-label-wrap,
					.eng-id-wrap,
					.code-label-wrap {
						max-width: 4rem;
						display: flex;

						.client-label,
						.eng-id-label,
						.code-label {
							display: inline-block;
							width: 100%;
						}
					}
				}

				.show-no-details {
					.eng-id,
					.client-code {
						display: none;
					}
				}

				.show-details {
					.client-code,
					.eng-id {
						max-width: 100%;
					}
				}
			}
		}
	}

	.orgChart-container {
		width: 69%;
		border: solid 1px ${(props) => props.theme.color[`grey300`]};
		border-radius: 0.8rem;
	}

	.check-eng-wrapper {
		display: flex;
		align-items: center;
		margin-bottom: 1rem;

		&:last-child {
			margin-bottom: 0;
		}
	}

	.motif-progress-loader-container {
		z-index: 2;
	}

	.boc-toolbar-container {
		left: var(--px-18);
		top: var(--px-18);
		display: flex;
		flex-direction: column;
		width: 4rem;
	}
`;
